import { RedirectToStatusOrShowOfferStepWrapper } from '@components/TireOffer/RedirectToStatusOrShowOfferStepWrapper';
import { AddressPickerWithDeliveryCheck } from './AddressPickerWithDeliveryCheck';

export const TireOfferAddress = () => {
  return (
    <RedirectToStatusOrShowOfferStepWrapper>
      {(tireOffer) => <AddressPickerWithDeliveryCheck tireOffer={tireOffer} />}
    </RedirectToStatusOrShowOfferStepWrapper>
  );
};
